import { useMemo } from 'react';
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';
import PersonIcon from '@mui/icons-material/Person';
import { togglePinnedFiltersState, selectBillingPinnedFilters } from '@store';
import { useHasFilters } from 'hooks/common';

export const useBillingFilterConfig = ({ assignees }) => {
  const router = useRouter();
  const dispatch = useDispatch();

  const pinnedFilters = useSelector(selectBillingPinnedFilters);
  const { hasFilters } = useHasFilters({
    pinnedFilters,
    omitParams: [
      'page',
      'view',
      'pageSize',
      'order',
      'orderBy',
      'query',
      'viewMode',
      'board',
    ],
  });

  const filterCategories = useMemo(
    () => [
      {
        id: 'assignee',
        label: 'Assignee',
        icon: PersonIcon,
        options: assignees || [],
        multiSelect: false,
      },
    ],
    [assignees]
  );
  const handlePinnedFilterSelect = (pinnedFilter) => {
    dispatch(togglePinnedFiltersState({ board: 'billing', pinnedFilter }));
  };

  const currentFilters = useMemo(() => {
    const parseQueryValue = (value) => {
      if (!value) return [];
      if (typeof value === 'string') {
        return value.split(',').filter(Boolean);
      }
      return Array.isArray(value) ? value : [];
    };

    return {
      assignee: parseQueryValue(router.query.assignee),
    };
  }, [router.query]);

  return {
    hasFilters,
    filterCategories,
    currentFilters,
    handlePinnedFilterSelect,
    pinnedFilters,
    supportPinnedFilters: true,
  };
};
